import { useState } from 'react';
import { Button, Icon } from '@/kit';
import { useMeStore } from '@/store/meStore';

const TRIGGERS = [
  { key: 'open_app', label: 'About to open the app' },
  { key: 'scroll_spiral', label: 'About to disappear into scrolling' },
  { key: 'cancel_plans', label: 'About to cancel plans' },
  { key: 'default', label: 'Something else' },
];

export function ImClosePage() {
  const runImClose = useMeStore((s) => s.runImClose);
  const markHelped = useMeStore((s) => s.markInterventionHelped);
  const [result, setResult] = useState<{
    title: string;
    action: string;
    why: string;
    interventionId: string;
  } | null>(null);
  const [feedback, setFeedback] = useState<'yes' | 'no' | null>(null);

  const fire = (triggerKey: string) => {
    setFeedback(null);
    setResult(runImClose(triggerKey));
  };

  return (
    <div className="space-y-8">
      <header>
        <p className="text-[10px] font-extrabold uppercase tracking-hottr-stamp text-hottr-pink">
          Decision point
        </p>
        <h1 className="mt-1 font-display text-3xl font-black uppercase tracking-hottr-display">
          I&apos;m Close
          <span className="text-hottr-pink">.</span>
        </h1>
        <p className="mt-2 max-w-md text-sm text-white/55">
          One immediate action. No form. No lecture.
        </p>
      </header>

      {!result && (
        <ul className="space-y-2">
          {TRIGGERS.map((t) => (
            <li key={t.key}>
              <button
                type="button"
                onClick={() => fire(t.key)}
                className="flex w-full items-center justify-between rounded-sm border border-white/12 bg-hottr-charcoal px-4 py-4 text-left transition-colors hover:border-hottr-pink/40"
              >
                <span className="text-[13px] font-semibold">{t.label}</span>
                <Icon name="chevron_right" className="text-white/40 text-[20px]" />
              </button>
            </li>
          ))}
        </ul>
      )}

      {result && (
        <article className="rounded-sm border border-hottr-pink/40 bg-hottr-pink/5 p-6">
          <p className="text-[10px] font-extrabold uppercase tracking-hottr-stamp text-hottr-pink">
            {result.title}
          </p>
          <p className="mt-4 font-display text-2xl font-black uppercase leading-snug tracking-hottr-display">
            {result.action}
          </p>
          <p className="mt-4 text-[13px] text-white/55">{result.why}</p>

          {feedback === null ? (
            <div className="mt-6">
              <p className="mb-3 text-[10px] font-extrabold uppercase tracking-hottr-label text-white/48">
                Did that help?
              </p>
              <div className="flex gap-2">
                <Button
                  variant="primary"
                  fullWidth
                  onClick={() => {
                    markHelped(result.interventionId, true);
                    setFeedback('yes');
                  }}
                >
                  Yes
                </Button>
                <Button
                  variant="secondary"
                  fullWidth
                  onClick={() => {
                    markHelped(result.interventionId, false);
                    setFeedback('no');
                  }}
                >
                  Not really
                </Button>
              </div>
            </div>
          ) : (
            <p className="mt-6 text-sm text-white/72">
              {feedback === 'yes'
                ? 'Logged. That counts as Momentum — urge interrupted.'
                : 'Logged. No shame. Try another angle when you need it.'}
            </p>
          )}

          <Button
            className="mt-4"
            variant="tertiary"
            onClick={() => {
              setResult(null);
              setFeedback(null);
            }}
          >
            Another trigger
          </Button>
        </article>
      )}
    </div>
  );
}
